export const isPerformanceOnDate = (date, performances) => {
    const dayjs = useDayjs()
    const targetDate = dayjs(date).tz('America/Chicago').startOf('date')
    return performances.some((performance) => {
        const performanceDate = dayjs(performance.performanceDateTime).tz('America/Chicago').startOf('date')
        return performanceDate.isSame(targetDate)
    });
};
